import React from "react";

// Illustrations de la partie réglementaire (Centre des règles) — noir/gris/blanc uniquement,
// comme le reste d'OLTODO (voir ACCENT dans styles/tokens.ts, réservé aux rares touches
// interactives, jamais à de l'illustration). Construites à partir de formes simples (rect/
// circle/path à coins arrondis) plutôt que de tracés complexes, dans le même esprit que les
// icônes déjà utilisées ailleurs dans l'app (FastCategoryIcons, components/move/MoveIcons) :
// trait fin (1.6-1.8), remplissages gris clair pour la profondeur, jamais de couleur.
// Chaque illustration partage le même gabarit 200×160, pensé pour tenir dans une tuile carrée.

const stroke = "#0a0a0a";
const fillLight = "#F0F0F0";
const fillMid = "#E2E2E2";

export const ContractIllustration = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="52" y="20" width="96" height="120" rx="10" fill="white" stroke={stroke} strokeWidth="2"/>
    <rect x="68" y="42" width="64" height="6" rx="3" fill={fillMid}/>
    <rect x="68" y="58" width="64" height="6" rx="3" fill={fillLight}/>
    <rect x="68" y="74" width="44" height="6" rx="3" fill={fillLight}/>
    <rect x="68" y="94" width="64" height="6" rx="3" fill={fillLight}/>
    <rect x="68" y="110" width="30" height="6" rx="3" fill={fillLight}/>
    <circle cx="140" cy="122" r="24" fill="#0a0a0a"/>
    <path d="M129 122l7 7 14-14" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ShieldIllustration = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M100 18l40 16v34c0 32-17 54-40 46-23 8-40-14-40-46V34z" fill="white" stroke={stroke} strokeWidth="2" strokeLinejoin="round"/>
    <path d="M100 18l40 16v34c0 32-17 54-40 46z" fill={fillLight}/>
    <path d="M84 74l12 12 22-24" stroke={stroke} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="34" cy="128" r="14" fill={fillMid} stroke={stroke} strokeWidth="1.6"/>
    <circle cx="166" cy="128" r="14" fill={fillMid} stroke={stroke} strokeWidth="1.6"/>
    <path d="M20 146c2-8 7-12 14-12s12 4 14 12" stroke={stroke} strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M152 146c2-8 7-12 14-12s12 4 14 12" stroke={stroke} strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);

export const LockIllustration = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="56" y="70" width="88" height="66" rx="12" fill="white" stroke={stroke} strokeWidth="2"/>
    <path d="M72 70V50a28 28 0 0 1 56 0v20" stroke={stroke} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="100" cy="98" r="9" fill={fillMid} stroke={stroke} strokeWidth="1.6"/>
    <rect x="97" y="104" width="6" height="16" rx="3" fill={stroke}/>
    <circle cx="34" cy="40" r="5" fill={fillMid}/>
    <circle cx="166" cy="52" r="4" fill={fillLight}/>
    <circle cx="160" cy="24" r="3" fill={fillMid}/>
  </svg>
);

export const CardIllustration = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="34" y="46" width="116" height="76" rx="12" fill="white" stroke={stroke} strokeWidth="2"/>
    <rect x="34" y="64" width="116" height="16" fill="#0a0a0a"/>
    <rect x="46" y="98" width="38" height="8" rx="4" fill={fillLight}/>
    <rect x="46" y="112" width="24" height="6" rx="3" fill={fillLight}/>
    <circle cx="150" cy="34" r="22" fill="white" stroke={stroke} strokeWidth="2"/>
    <path d="M158 24a10 10 0 0 0-15 10" stroke={stroke} strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M142 44a10 10 0 0 0 15-10" stroke={stroke} strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="132" y1="34" x2="142" y2="34" stroke={stroke} strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="158" y1="34" x2="168" y2="34" stroke={stroke} strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

export const CookieIllustration = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M100 26a54 54 0 1 0 52 68 16 16 0 0 1-18-18 16 16 0 0 1-18-18 16 16 0 0 1-16-16 16 16 0 0 1-0-16z" fill={fillLight} stroke={stroke} strokeWidth="2" strokeLinejoin="round"/>
    <circle cx="80" cy="58" r="5" fill={stroke}/>
    <circle cx="112" cy="52" r="4" fill={stroke}/>
    <circle cx="66" cy="90" r="4" fill={stroke}/>
    <circle cx="96" cy="104" r="5" fill={stroke}/>
    <circle cx="126" cy="98" r="3.5" fill={stroke}/>
    <circle cx="80" cy="122" r="4" fill={stroke}/>
  </svg>
);

export const ScaleIllustration = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="100" y1="26" x2="100" y2="120" stroke={stroke} strokeWidth="2"/>
    <line x1="46" y1="46" x2="154" y2="46" stroke={stroke} strokeWidth="2" strokeLinecap="round"/>
    <rect x="86" y="120" width="28" height="10" rx="3" fill={stroke}/>
    <rect x="70" y="130" width="60" height="8" rx="4" fill={fillMid}/>
    <path d="M46 46l-20 40a20 20 0 0 0 40 0z" fill="white" stroke={stroke} strokeWidth="1.8" strokeLinejoin="round"/>
    <path d="M154 46l-20 40a20 20 0 0 0 40 0z" fill="white" stroke={stroke} strokeWidth="1.8" strokeLinejoin="round"/>
    <circle cx="100" cy="30" r="6" fill={fillLight} stroke={stroke} strokeWidth="1.6"/>
  </svg>
);
